<template>
  <detail envName="生产环境"
    :envInfoType='3' />
</template>

<script>
import Detail from '@/components/business/traceinfo/detail'
export default {
  name: 'work-env-detail',
  components: { Detail },
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {},
  methods: {},
  created () { },
  mounted () { }
}
</script>
<style lang="stylus" scoped></style>
